import commitChangesToUserOptions from '../mutators/commitChangesToUserOptions';
import { getUserConfiguration } from 'owa-session-store';
import setNotificationSettings from '../services/setNotificationSettings';

export default async function saveAppNotificationOptions() {
    // Save the changes locally
    commitChangesToUserOptions();

    // Make service request to save settings to the server
    const userOptions = getUserConfiguration().UserOptions;

    await setNotificationSettings(
        userOptions.NewItemNotify,
        userOptions.EnableReminders,
        userOptions.EnableReminderSound
    );
}
